import React, { useState, useEffect } from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Home, Info, Business, Security, ContactMail, Star } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const menuItems = [
  { text: 'Home', icon: <Home />, path: '/' },
  { text: 'About Us', icon: <Info />, path: '/about' },
  { text: 'Products & Services', icon: <Business />, path: '/products-services' },
  { text: 'Safety & Quality', icon: <Security />, path: '/safety-quality' },
  { text: 'Contact', icon: <ContactMail />, path: '/contact' },
  { text: 'Success Stories', icon: <Star />, path: '/success-stories' },
];

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);

  // Larger hover area for more stable expansion
  useEffect(() => {
    const handleMouseMove = (event) => {
      if (event.clientX <= 150) setIsOpen(true); // Expanded on wider hover area
      else setIsOpen(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <motion.div
      animate={{ width: isOpen ? 250 : 70 }} 
      transition={{ duration: 0.3 }}
      style={{ position: 'fixed', height: '100vh', zIndex: 1200 }}
    >
      <Drawer
        variant="permanent"
        sx={{
          width: isOpen ? 250 : 70, 
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: isOpen ? 250 : 70,
            boxSizing: 'border-box',
            transition: 'width 0.3s ease-in-out',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
        }}
      >
        {/* Logo Section */}
        <div style={{ width: '100%', padding: isOpen ? '20px' : '10px', textAlign: 'center' }}>
          <img
            src="/logo.jpg"
            alt="MBPE Logo"
            width={isOpen ? 120 : 50}
            height={isOpen ? 120 : 50}
            style={{ transition: 'width 0.3s, height 0.3s' }}
          />
        </div>

        {/* Menu Items */}
        <List>
          {menuItems.map(({ text, icon, path }) => (
            <ListItem key={text} disablePadding>
              <ListItemButton component={NavLink} to={path} sx={{ justifyContent: isOpen ? 'initial' : 'center' }}>
                <ListItemIcon sx={{ minWidth: 40 }}>{icon}</ListItemIcon>
                {isOpen && <ListItemText primary={text} />}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </motion.div>
  );
}

export default Sidebar;
